module.exports = __webpack_public_path__ + "img/49.41832423.png";